export const LINK_TYPES = {
  ellipse: 'ellipse',
  slider: 'slider',
};
